<div *ngIf="!isLoading" class="favorites-container">
  <ng-container *ngIf="favoritesClubs?.length">
    <div class="cards-list">
      <app-channel-card
        *ngFor="let channel of favoritesClubs"
        [profile]="channel"
        [isClub]="true"
      ></app-channel-card>
    </div>
  </ng-container>

  <ng-container *ngIf="!favoritesClubs?.length">
    <div class="empty">
      <img
        src="assets/ui/images/svg/empty-favorites.svg"
        width="130"
        height="130"
        alt="empty-favorites"
      />
      <div class="empty__text">Time to stock up!</div>
      <a class="empty__button" [routerLink]="'/channels'">explore channels</a>
    </div>
  </ng-container>
</div>
